// FCM 푸시 — 주말나들이 알림 (2026-07-27)
// @capacitor-firebase/messaging 사용: 권한 요청 → 토픽 구독(전역 'weekend' + 지역 'wk_<시>_<구>') → 알림 탭 처리.
// 웹/데스크톱에선 no-op. 실패가 앱을 막지 않도록 전부 try/catch.
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';

const _native = () => !!(Capacitor && Capacitor.isNativePlatform && Capacitor.isNativePlatform());
const _enc = (s) => encodeURIComponent(String(s || '').trim());
// FCM 토픽명 규칙 [a-zA-Z0-9-_.~%] — 한글은 %인코딩으로 안전 처리. 서버도 동일 규칙으로 발송.
export const regionTopic = (city, district) => (city && district) ? `wk_${_enc(city)}_${_enc(district)}` : '';

let _inited = false;
let _openHandler = null;

// 앱 진입(홈) 시 1회 호출 — 권한·구독·탭리스너 설정. onOpen(data): 알림 탭 시 실행.
export async function initWeekendPush(user, onOpen) {
  _openHandler = onOpen || _openHandler;
  if (_inited || !_native()) return;
  _inited = true;
  try {
    let perm = await FirebaseMessaging.checkPermissions();
    if (perm.receive !== 'granted') perm = await FirebaseMessaging.requestPermissions();
    if (perm.receive !== 'granted') { _inited = false; return; }

    // iOS 필수: FCM 토큰 발급 = APNs 등록 트리거. 이게 있어야 토픽 구독이 실제 기기에 매핑돼 전달됨.
    // APNs 토큰이 아직 준비 안 됐으면 잠깐 뒤 1회 재시도.
    let _tok = '';
    try {
      const t = await FirebaseMessaging.getToken();
      _tok = (t && t.token) || '';
      if (!_tok) throw new Error('no token yet');
    } catch (e) {
      await new Promise((r) => setTimeout(r, 3000));
      try { const t2 = await FirebaseMessaging.getToken(); _tok = (t2 && t2.token) || ''; } catch (_) {}
    }
    // 디버그: 발급된 토큰을 서버에 등록 → 토큰 직접발송으로 원인 격리 (v3.5.0 검증 후 제거)
    if (_tok) {
      try { localStorage.setItem('gadeuk_fcm_token', _tok); } catch (_) {}
      const plat = (Capacitor && Capacitor.getPlatform && Capacitor.getPlatform()) || '';
      try { fetch('https://asia-northeast3-gadeuk-app.cloudfunctions.net/registerPushToken?token=' + encodeURIComponent(_tok) + '&platform=' + plat); } catch (_) {}
    }

    await FirebaseMessaging.subscribeToTopic({ topic: 'all' });      // 전체 공지·업데이트 소식
    await FirebaseMessaging.subscribeToTopic({ topic: 'weekend' });  // 주말 나들이 알림
    const rt = regionTopic(user && user.city, user && user.district);
    if (rt) {
      try { localStorage.setItem('gadeuk_wk_topic', rt); } catch (_) {}
      await FirebaseMessaging.subscribeToTopic({ topic: rt });
    }

    // 알림 눌러 앱 열었을 때
    await FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
      const data = (event && event.notification && event.notification.data) || {};
      if (_openHandler) { try { _openHandler(data); } catch (_) {} }
    });
  } catch (e) {
    _inited = false; // 다음 기회에 재시도 (권한 팝업 취소 등)
  }
}

// 지역 변경(이사·프로필 수정) 시 — 옛 토픽 해제 후 새 토픽 구독
export async function updateRegionTopic(user) {
  if (!_native()) return;
  try {
    const rt = regionTopic(user && user.city, user && user.district);
    if (!rt) return;
    let old = ''; try { old = localStorage.getItem('gadeuk_wk_topic') || ''; } catch (_) {}
    if (old === rt) return;
    if (old) { try { await FirebaseMessaging.unsubscribeFromTopic({ topic: old }); } catch (_) {} }
    await FirebaseMessaging.subscribeToTopic({ topic: rt });
    try { localStorage.setItem('gadeuk_wk_topic', rt); } catch (_) {}
  } catch (_) {}
}
